import { type FanResponseDto, OfChatNotificationsService } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { toggleFollow } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const useToggleFollow = (onSuccess?: (state: boolean) => void) => {
  const creatorId = useUnit($creatorId)
  const toast = useToast()
  const followMutation = useMutation(
    (fanId: FanResponseDto['id']) =>
      OfChatNotificationsService.subscribe({ creatorId: creatorId!, fanId }),
    {
      onSuccess: (updatedChat) => {
        // no fan details in response
        toggleFollow({
          fanId: updatedChat.withUser!.id,
          subscribedBy: true,
          canSendMessage: updatedChat.canSendMessage,
          canNotSendReason: updatedChat.canNotSendReason!,
        })
        onSuccess?.(true)
        toast.success('Followed successfully')
      },
      onError: (error) => {
        handleError(error, 'Something went wrong while following user')
      },
    },
  )

  const unfollowMutation = useMutation(
    (fanId: FanResponseDto['id']) =>
      OfChatNotificationsService.unsubscribe({ creatorId: creatorId!, fanId }),
    {
      onSuccess: (updatedChat) => {
        // no fan details in response
        toggleFollow({
          fanId: updatedChat.withUser!.id,
          subscribedBy: false,
          canSendMessage: updatedChat.canSendMessage,
          canNotSendReason: updatedChat.canNotSendReason!,
        })
        onSuccess?.(false)
        toast.success('Unfollowed successfully')
      },
      onError: (error) => {
        handleError(error, 'Something went wrong while unfollowing user')
      },
    },
  )

  return {
    followMutation,
    unfollowMutation,
  }
}
